import { observer } from "mobx-react";
import type React from "react";

import { SeparatorLine } from "components/SeparatorLine";
import { CssFlex } from "styles/helpers/layout";
import { ChangeTestOwnerForm } from "./components/ChangeTestOwnerForm/ChangeTestOwnerForm";
import { DeleteAccounts } from "./components/DeleteAccounts/DeleteAccounts";
import { DownloadInvitesReport } from "./components/DownloadInvitesReport/DownloadInvitesReport";
import { DownloadUsersReport } from "./components/DownloadUsersReport/DownloadUsersReport";
import { TransferResults } from "./components/TransferResults/TransferResults";

export const UserToolsPage: React.FC = observer(() => (
  <CssFlex flexDirection="column" gap={2}>
    <TransferResults />
    <SeparatorLine direction="horizontal" />
    <ChangeTestOwnerForm />
    <SeparatorLine direction="horizontal" />
    <DownloadInvitesReport />
    <SeparatorLine direction="horizontal" />
    <DownloadUsersReport />
    <SeparatorLine direction="horizontal" />
    <DeleteAccounts />
  </CssFlex>
));
